import { ROLES } from '../../../../constants';

/** @typedef {'system-admin'|'super-admin'|'facility-admin'|'attorney'|'messaging-only'|'facility-staff'|'staff-business'|'default-muted'} RoleIconVariant */

/**
 * Ordered rules: first match wins. Substring checks use lowercased displayName / roleName.
 * System Admin is checked before Super Admin so names are not confused.
 * @type {Array<[(roleType: string, contains: (substring: string) => boolean) => boolean, RoleIconVariant]>}
 */
const ROLE_ICON_RULES = [
  [(rt, c) => rt === ROLES.SYSTEM_ADMIN || c('system admin'), 'system-admin'],
  [(rt, c) => rt === ROLES.SUPER_ADMIN || c('super admin'), 'super-admin'],
  [(rt, c) => c('facility admin'), 'facility-admin'],
  [(rt, c) => rt === ROLES.ATTORNEY || c('attorney'), 'attorney'],
  [(rt, c) => rt === ROLES.MESSAGING_ONLY || c('messaging'), 'messaging-only'],
  [(rt, c) => c('facility staff') || rt === ROLES.TEACHER || c('teacher'), 'facility-staff'],
  [(rt, c) => rt === ROLES.STAFF || c('staff'), 'staff-business'],
];

/**
 * Maps API role fields to a stable icon variant for the role card.
 * @param {{ roleType?: string, displayName?: string, roleName?: string }} role
 * @returns {RoleIconVariant}
 */
export function resolveRoleIconVariant(role) {
  if (!role) return 'default-muted';

  const roleType = role.roleType || '';
  const display = (role.displayName || '').toLowerCase();
  const name = (role.roleName || '').toLowerCase();
  const contains = (substring) => display.includes(substring) || name.includes(substring);

  for (const [match, variant] of ROLE_ICON_RULES) {
    if (match(roleType, contains)) return variant;
  }
  return 'default-muted';
}
